import React from "react";
import "./Solucoes.css";
import { CheckCircle } from "lucide-react";

const Solucoes = () => {
  const publicoAlvo = [
    "Quem já tentou com outras agências, mas não encontrou método nem resultado consistente",
    "Consultórios com boa demanda, mas que não têm previsibilidade de crescimento",
    "Equipes que precisam de método, clareza e alinhamento",
    "Quem já fatura alto e quer escalar com estrutura",
    "Quem está começando e quer fazer certo desde o início",
    "Dentistas e médicos que querem sair da estagnação",
  ];

  return (
    <section id="atuacao" className="solucoes-section" data-aos="fade-in">
      <div className="solucoes-container">
        <div className="solucoes-header">
          <span className="cases-label">Quem Atendemos</span>
          <h2 className="solucoes-title">
            Pra quem é o <span className="highlight">Projeto Arcadian?</span>
          </h2>
          <p className="solucoes-subtitle">
            Nosso projeto foi desenhado para clínicas e consultórios que buscam
            performance, método e crescimento previsível.
          </p>
        </div>

        <div className="solucoes-grid">
          {publicoAlvo.map((item, index) => (
            <div key={index} className="solucoes-card">
              <div className="solucoes-card-content">
                <div className="solucoes-icon-title">
                  <div className="solucoes-icon-wrapper">
                    <CheckCircle className="solucoes-icon" />
                  </div>
                  <h3 className="solucoes-card-title">{item}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="solucoes-bottom-cta">
          <a
            href="https://wa.me/5577981631390?text=Ol%C3%A1%2C%20vim%20do%20site%20da%20Arcadian%20e%20gostaria%20faturar%20mais%20com%20a%20minha%20cl%C3%ADnica!"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn-primary">
              Quero Avaliar se a Arcadian é pra Mim
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Solucoes;
